import type { Price } from 'types/capi/shared';

import {
  type ContractStockStatus,
  type StockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

const NO_PRICE = -1;

export type RaffleEntryTargetProperties = {
  clickref: string;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_id: string;
  retailer_id?: string;
  stock_status: ContractStockStatus;
};

type EventData = {
  clickref: string;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  price: Price;
  productId: number;
  retailerId?: string;
  stockStatus: StockStatus;
};

class RaffleEntryInteractionEvent extends InteractionEvent<
  EventData,
  RaffleEntryTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'raffle_entry';
  }

  protected getTargetProperties(): RaffleEntryTargetProperties {
    return {
      clickref: this.data.clickref,
      price_currency: this.data.price.currency,
      price_regular: this.data.price.regular ?? NO_PRICE,
      price_sale: this.data.price.sale ?? undefined,
      product_id: String(this.data.productId),
      retailer_id: this.data.retailerId,
      stock_status: toContractStockStatus(this.data.stockStatus)
    };
  }
}

export default RaffleEntryInteractionEvent;
